export default __webpack_public_path__ + "static/media/30.e53f437f.wav";